import { inject } from "../../../../../lib/itn-ui-kit/services/service-container";
import StandardTabPanel from "../../../../components/ui library/components/tab-panels/standard/StandardTabPanel";
import { TAB_STYLES } from "../../../ui library/components/tab-panels/standard/tab-header/tab-styles";

const permissions = {
  contacts: "core.view_contact",
};

export default function Navigation({ _case, activeTab, children }) {
  const currentUserService = inject("current-user-service");
  const userPermissions = currentUserService?.userRoles?.permissions || [];
  const canViewContacts = userPermissions.includes(permissions.contacts);

  const allTabs = [
    {
      key: "client-info",
      name: "Client Info",
      isDisabled: false,
      permission: null,
      href: `/client-detail/${_case.id}/client-info/personal`,
    },
    {
      key: "actionable-items",
      name: "Actionable Items",
      isDisabled: false,
      permission: null,
      href: `/client-detail/${_case.id}/actionable-items`,
    },
    {
      key: "medical",
      name: "Medical",
      isDisabled: false,
      permission: null,
      href: `/client-detail/${_case.id}/medical/providers`,
    },
    /*     {
      key: "documents",
      name: "Documents",
      isDisabled: false,
      permission: null,
      href: `/client-detail/${_case.id}/documents/folders`,
    }, */
    {
      key: "case",
      name: "Case",
      isDisabled: false,
      permission: null,
      href: `/client-detail/${_case.id}/case/general`,
    },
    {
      key: "contacts",
      name: "Contacts",
      isDisabled: false,
      permission: canViewContacts,
      href: `/client-detail/${_case.id}/contacts`,
    },
  ];

  return (
    <div className="transparent flex h-full flex-1 flex-col items-stretch rounded-[15px] shadow-[3px_3px_10px_0px_rgb(188,209,255)]">
      <StandardTabPanel
        activeTab={activeTab}
        tabList={allTabs}
        headerTabSx={TAB_STYLES.TAB.SX}
        headerTabIndicatorSx={TAB_STYLES.TAB.TAB_INDICATOR_SX}
      >
        {children}
      </StandardTabPanel>
    </div>
  );
}
